import { Skeleton } from "@/components/ui/skeleton";
import { Card, CardContent } from "@/components/ui/card";

export const ProfileSkeleton = () => {
  return (
    <Card className="max-w-2xl mx-auto">
      <CardContent className="space-y-6 pt-6">
        {/* Profile Header */}
        <div className="flex items-center gap-4">
          <Skeleton className="h-20 w-20 rounded-full" />
          <div className="space-y-2">
            <Skeleton className="h-6 w-32" />
            <Skeleton className="h-4 w-24" />
          </div>
        </div>

        {/* Bio Section */}
        <div className="space-y-2">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-20 w-full" />
        </div>

        {/* Location */}
        <Skeleton className="h-6 w-48" />

        {/* Languages */}
        <div className="space-y-2">
          <Skeleton className="h-4 w-28" />
          <div className="flex gap-2">
            <Skeleton className="h-8 w-20" />
            <Skeleton className="h-8 w-24" />
            <Skeleton className="h-8 w-16" />
          </div>
        </div>

        {/* Edit Button */}
        <Skeleton className="h-10 w-full" />
      </CardContent>
    </Card>
  );
};